import React, { useMemo } from 'react'
import { Title, Text } from 'components/atoms'
import { Modal } from 'components/molecules'
import { PageCreateForm } from 'components/organisms'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { publishContent } from 'services/requests'
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { generateInitialPageData } from 'services/generators'
import { useEditorContext, actions, status } from 'context/EditorContext'

const copy = {
  en: {
    title: 'Versão inglesa da página',
    subtitle: 'Para adicionar e editar a versão inglesa da página preencha os seguintes campos'
  },
  pt: {
    title: 'Versão portuguesa da página',
    subtitle: 'Para adicionar e editar a versão portuguesa da página preencha os seguintes campos'
  },
  default: {
    title: 'Versão em nova língua',
    subtitle: 'Para adicionar e editar a página preencha os seguintes campos'
  }
}

const PageCreateLanguageModal = ({
  isOpen,
  toggle,
  newLanguage,
}) => {
  const { subweb, pageId, lang } = useParams()
  const [, dispatch] = useEditorContext()

  const handleSubmit = async ({ slug, title }) => {
    try {
      // create new empty draft page for new language
      const { data: { pageContent: newPage, otherLanguageContent } } = await publishContent({
        subweb,
        pageId,
        language: newLanguage,
        pageData: generateInitialPageData({ title }),
        state: 1,
        slug,
      })
      dispatch({
        type: actions.PAGE_ADD,
        data: {
          liveData: newPage,
          savedData: newPage,
          status: status.draft,
          slug,
          otherLanguageContent
        },
      });
      toggle()
      toast.success(
        <Toast
          type="success"
          title="Página criada"
          description={`versão ${lang}`}
        />
      );
    } catch (err) {
      if (err.response && err.response.status === 409) {
        toast.error(
          <Toast
            type="error"
            title="Endereço amigável já existe."
            description="Experimente introduzir outro endereço amigável."
          />
        );
      } else {
        toast.error(
          <Toast
            type="error"
            title="Erro a criar página."
            description={err.message}
          />
        );
      }
    }
  }

  const langCopy = useMemo(() => {
    if (newLanguage in copy) return copy[newLanguage]
    return copy.default
  }, [newLanguage])

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <Modal.Top>
        <Title>
          {langCopy.title}
        </Title>
        <Text>
          {langCopy.subtitle}
        </Text>
      </Modal.Top>
      <PageCreateForm
        subweb={subweb}
        lang={lang}
        onSubmit={handleSubmit}
        onDiscard={toggle}
      />
    </Modal>
  )
}

PageCreateLanguageModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  newLanguage: PropTypes.string.isRequired
}

PageCreateLanguageModal.defaultProps = {
  isOpen: false,
  toggle: () => {}
}

export default PageCreateLanguageModal
